// extracted by mini-css-extract-plugin
export default {"fragnetSummaryWrapper":"ActivitiesPredecessors_fragnetSummaryWrapper__lCu1a"};